export const BUSINESS = {
  name: "BaySmog",
  legalName: "Bay Smog Check",
  phone: "(510) 887-4735",
  phoneHref: "tel:+15108874735",
  email: "Baysmog2024@gmail.com",
  emailHref: "mailto:Baysmog2024@gmail.com",
  street: "258 W Tennyson Rd",
  city: "Hayward",
  state: "CA",
  zip: "94544",
  fullAddress: "258 W Tennyson Rd, Hayward, CA 94544",
  hours: [
    { days: "Monday – Friday", time: "9:00 AM – 6:00 PM" },
    { days: "Saturday", time: "9:00 AM – 5:00 PM" },
    { days: "Sunday", time: "Closed" },
  ],
  hoursShort: "Mon–Fri 9 AM–6 PM | Sat 9 AM–5 PM",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=BaySmog%2C+258+W+Tennyson+Rd%2C+Hayward%2C+CA+94544",
  mapsPlace:
    "https://www.google.com/maps/search/?api=1&query=BaySmog+258+W+Tennyson+Rd+Hayward+CA+94544",
  mapsEmbed:
    "https://www.google.com/maps?q=BaySmog,+258+W+Tennyson+Rd,+Hayward,+CA+94544&output=embed",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2000&auto=format&fit=crop",
  garage: "https://images.unsplash.com/photo-1625047509168-a7026f36de04?q=80&w=1600&auto=format&fit=crop",
  skyline: "https://images.unsplash.com/photo-1501594907352-04cda38ebc29?q=80&w=1600&auto=format&fit=crop",
  shop: "/storefront.jpg",
};

export const SERVICES = [
  {
    slug: "smog-check-hayward",
    num: "01",
    icon: "Gauge",
    title: "Smog Check",
    seoTitle: "Smog Check Hayward CA — Fast Smog Test Near I-880 | BaySmog",
    short: "Fast, certified smog checks for most cars, trucks, SUVs and vans — walk-ins welcome.",
    image: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?q=80&w=1400&auto=format&fit=crop",
    intro:
      "BaySmog is a California-licensed smog check station on W Tennyson Road in Hayward, minutes from the I-880 / Tennyson Road interchange. If your DMV renewal notice says you need a smog inspection, drive in — most smog tests are completed in about 15–20 minutes.",
    bullets: [
      "All smog checks performed to California BAR standards",
      "Most vehicles tested in about 15–20 minutes",
      "Walk-ins welcome — no appointment needed",
      "Electronic results sent straight to the DMV",
      "Cars, trucks, SUVs, vans and RVs",
      "Clear pass/fail report with honest next steps",
    ],
    body: "We test 1996-and-newer OBD-II vehicles as well as older models that require a tailpipe and visual inspection. When your vehicle passes, the certificate is transmitted electronically to the DMV the same visit, so your registration renewal is never held up. If it doesn't pass, we'll explain exactly why — in plain language — before you spend a dollar on repairs.",
    keywords: "smog check Hayward CA, smog test Hayward, smog station near me, emissions testing Hayward",
  },
  {
    slug: "star-smog-check-hayward",
    num: "02",
    icon: "Star",
    title: "STAR Smog Check",
    seoTitle: "STAR Smog Check Hayward — STAR Certified Station | BaySmog",
    short: "STAR-certified station for vehicles directed by the DMV to a STAR smog check.",
    image: "https://images.unsplash.com/photo-1489824904134-891ab64532f1?q=80&w=1400&auto=format&fit=crop",
    intro:
      "If your DMV renewal notice says 'STAR station required,' BaySmog has you covered. We are a STAR-certified smog check station in Hayward, meeting the Bureau of Automotive Repair's highest performance standards.",
    bullets: [
      "STAR-certified by the California Bureau of Automotive Repair",
      "We test vehicles that the DMV directs to STAR stations",
      "Gross polluter and high-emitter profile vehicles accepted",
      "Random DMV-directed STAR inspections welcome",
      "Same fast visit — usually 15–20 minutes",
      "Certificates transmitted electronically to the DMV",
    ],
    body: "STAR stations are held to a higher standard by the State of California and are authorized to inspect any vehicle — including those flagged as potential high emitters. Whether your notice requires a STAR smog check or you simply want the most rigorous test available, our Tennyson Road station near I-880 makes it easy: pull in, get tested, and get back on the road.",
    keywords: "STAR smog check Hayward, STAR smog station near me, STAR certified smog Hayward CA",
  },
  {
    slug: "diesel-smog-check-hayward",
    num: "03",
    icon: "Truck",
    title: "Diesel Smog Check",
    seoTitle: "Diesel Smog Check Hayward CA — Diesel Emissions Testing | BaySmog",
    short: "Diesel smog checks for trucks, vans and RVs — done right, done fast.",
    image: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?q=80&w=1400&auto=format&fit=crop",
    intro:
      "Not every smog station can test diesel vehicles — BaySmog can. We perform diesel smog checks in Hayward for diesel cars, trucks, vans and motorhomes registered in California.",
    bullets: [
      "Diesel smog checks for most diesel vehicles",
      "Pickups, box trucks, vans and diesel RVs",
      "OBD and opacity testing per BAR requirements",
      "Results transmitted electronically to the DMV",
      "Convenient for contractors and fleet vehicles",
      "Easy freeway access from I-880 at Tennyson Rd",
    ],
    body: "California requires biennial smog checks for most 1998-and-newer diesel vehicles under 14,000 lbs GVWR. Our Hayward station handles the full diesel inspection — visual, functional and OBD — so commercial drivers and diesel owners can stay compliant without driving across the Bay. Bring your renewal notice and we'll take care of the rest.",
    keywords: "diesel smog check Hayward, diesel smog near me, diesel emissions testing Hayward CA",
  },
  {
    slug: "clean-truck-check-hayward",
    num: "04",
    icon: "Container",
    title: "Clean Truck Check",
    seoTitle: "Clean Truck Check Hayward — HD Truck Emissions Testing | BaySmog",
    short: "California Clean Truck Check (HD I/M) testing for heavy-duty trucks over 14,000 lbs.",
    image: "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?q=80&w=1400&auto=format&fit=crop",
    intro:
      "California's Clean Truck Check program requires periodic emissions testing for heavy-duty diesel trucks over 14,000 lbs GVWR. BaySmog provides Clean Truck Check testing in Hayward for owner-operators and fleets working the I-880 corridor.",
    bullets: [
      "Heavy-duty I/M (Clean Truck Check) OBD testing",
      "For diesel trucks over 14,000 lbs GVWR",
      "Owner-operators and fleet vehicles welcome",
      "Fast in-and-out testing near I-880",
      "Results reported per CARB program requirements",
      "Call ahead for fleet scheduling",
    ],
    body: "The Clean Truck Check (Heavy-Duty Inspection and Maintenance) program is separate from the standard smog check and applies to most heavy-duty trucks operating on California roads. Our team can test your truck and help you understand the reporting requirements, deadlines and compliance steps — so a missed test never sidelines your rig or your business.",
    keywords: "Clean Truck Check Hayward, HD I/M testing near me, heavy duty truck emissions Hayward",
  },
  {
    slug: "vin-verification-hayward",
    num: "06",
    icon: "ScanLine",
    title: "VIN Verification",
    seoTitle: "VIN Verification Hayward CA — Fast DMV VIN Verification | BaySmog",
    short: "Official VIN verification for out-of-state vehicles and DMV record corrections.",
    image: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?q=80&w=1400&auto=format&fit=crop",
    intro:
      "Need a VIN verification for the DMV? BaySmog performs fast, official VIN verifications in Hayward — commonly required when registering an out-of-state vehicle, correcting DMV records, or registering a vehicle with no California record.",
    bullets: [
      "VIN verification for out-of-state vehicles",
      "Required forms completed correctly the first time",
      "Often combined with a smog check in one visit",
      "Cars, trucks, motorcycles and trailers",
      "Fast service — usually under 10 minutes",
      "Walk-ins welcome during business hours",
    ],
    body: "A VIN verification is a physical inspection confirming your vehicle's identification number matches its paperwork. It's required for most vehicles coming into California from another state, and for certain DMV corrections. Our licensed verifiers complete the REG 31 form on the spot, and since we're also a smog station, most customers finish everything in a single stop.",
    keywords: "VIN verification Hayward, DMV VIN verification near me, out of state VIN check Hayward CA",
  },
  {
    slug: "smog-repair-hayward",
    num: "07",
    icon: "Wrench",
    title: "Smog-Related Repairs",
    seoTitle: "Smog Repair Hayward CA — Failed Smog Check Help | BaySmog",
    short: "Failed your smog check? We diagnose emissions problems and get you retested fast.",
    image: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?q=80&w=1400&auto=format&fit=crop",
    intro:
      "A failed smog check doesn't have to derail your week. BaySmog helps Hayward drivers understand why their vehicle failed and provides smog-related repair guidance and service to get you passing — and legally registered — as quickly as possible.",
    bullets: [
      "Honest explanation of your smog failure report",
      "Check-engine light and OBD-II diagnostics",
      "Common emissions repairs: sensors, EVAP, catalytic issues",
      "Pre-test checks before your official inspection",
      "Retest after repairs, with results sent to the DMV",
      "Straight talk on repair vs. cost — no pressure",
    ],
    body: "Most smog failures come down to a handful of common issues: oxygen sensors, EVAP leaks, catalytic converter efficiency, or readiness monitors that haven't set. We'll read your report, explain what it means in plain English, and give you clear options. Ask about California's Consumer Assistance Program if repair costs are a concern — we'll point you in the right direction.",
    keywords: "smog repair Hayward, failed smog check help, check engine light Hayward CA, emissions repair near me",
  },
];

export const LOCATIONS = [
  {
    slug: "hayward",
    city: "Hayward",
    primary: true,
    title: "Smog Check in Hayward, CA",
    seoTitle: "Smog Check Hayward CA — STAR Station on W Tennyson Rd | BaySmog",
    intro:
      "BaySmog's home base: 258 W Tennyson Rd, Hayward, CA 94544 — right off I-880 at the Tennyson Road exit. This is our physical station, where every smog check, STAR test and DMV service on this site actually happens.",
    body: [
      "Hayward drivers have plenty of options for a smog check, but few this convenient. Our station sits on W Tennyson Road just west of the I-880 interchange — an easy stop whether you're coming from Downtown Hayward, South Hayward, the Hayward hills, or heading home to Union City or San Leandro on the 880.",
      "We're a STAR-certified station, which means the Bureau of Automotive Repair holds us to its highest performance standard — and we can test any vehicle, including those the DMV specifically directs to a STAR station. Most smog checks take about 15–20 minutes, and walk-ins are always welcome during business hours.",
      "Beyond smog testing, we also offer VIN verification and diesel / Clean Truck Check testing. Many Hayward customers finish their smog certificate and VIN verification in a single visit.",
    ],
    highlights: [
      "STAR-certified station — all vehicles accepted",
      "2 minutes from I-880 at Tennyson Rd",
      "Smog + VIN verification in one visit",
      "Diesel and Clean Truck Check available",
    ],
  },
  {
    slug: "union-city",
    city: "Union City",
    primary: false,
    title: "Smog Check Near Union City, CA",
    seoTitle: "Smog Check Near Union City CA — STAR Station Minutes Away | BaySmog",
    intro:
      "Live in Union City and need a smog check? BaySmog is roughly 10 minutes north via I-880 — exit at Tennyson Road and you're practically here.",
    body: [
      "Union City drivers searching for a 'smog check near me' are closer to a STAR-certified station than they might think. BaySmog at 258 W Tennyson Rd in Hayward is a straight shot up I-880 — most Union City neighborhoods, from Decoto to the Union Landing area, reach us in about 10–15 minutes.",
      "Because we're STAR-certified, we can test vehicles that the DMV requires to visit a STAR station — something not every shop near Union City can offer. Add diesel smog checks, Clean Truck Check testing and VIN verification, and most drivers finish everything in one stop.",
      "Walk-ins are welcome Monday through Saturday. If you're renewing your registration, bring your DMV notice — we'll test your vehicle and transmit the certificate electronically in the same visit.",
    ],
    highlights: [
      "~10 minutes from Union City via I-880 N",
      "STAR-certified — DMV-directed vehicles accepted",
      "Smog check + VIN verification in one visit",
      "Walk-ins welcome Mon–Sat",
    ],
  },
  {
    slug: "san-leandro",
    city: "San Leandro",
    primary: false,
    title: "Smog Check Near San Leandro, CA",
    seoTitle: "Smog Check Near San Leandro CA — STAR Smog Station | BaySmog",
    intro:
      "San Leandro drivers: BaySmog's STAR-certified station is about 10 minutes south on I-880 at the Tennyson Road exit — fast smog checks with no appointment needed.",
    body: [
      "From anywhere in San Leandro — Bayfair, downtown, or the marina area — BaySmog is a quick drive down I-880 to W Tennyson Road in Hayward. It's one of the fastest ways for San Leandro residents to reach a STAR-certified smog station without fighting city traffic.",
      "We perform regular smog checks, STAR-directed inspections, diesel smog testing and Clean Truck Checks for heavy-duty vehicles. Most tests wrap up in 15–20 minutes and the results go straight to the DMV electronically.",
      "Need more than a smog check? We also offer VIN verification right here — San Leandro customers routinely finish their smog certificate and VIN verification in a single visit.",
    ],
    highlights: [
      "~10 minutes from San Leandro via I-880 S",
      "STAR-certified smog station",
      "Diesel & Clean Truck Check testing",
      "VIN verification on site",
    ],
  },
];

export const NAV_LINKS = [
  { label: "Services", href: "/services" },
  { label: "Coupon", href: "/#coupon" },
  { label: "Locations", href: "/locations/hayward" },
  { label: "Contact", href: "/contact" },
];
